import { ModelListener } from './ModelListener';
import { FieldModel } from '../../view-model/field-model';
import { ModelStateService } from '../view-model/model-state.service';
import { BaseModel, ModelWithChildren } from '../../view-model/base-model';

/**
 * Listens for Changes in part & lot on Environmental Legislation Organization Technical Identifier Reference (OPT-301)
 * & on Internet Address of Environmental Legislation Organization (OPT-120)
 * if a value is entered in one of the two fields, the Environmental Legislation Document ID(OPT-112) field is mandatory.
 * So the value of ID(OPT-112) will be set to "n.a"
 */
export class EnvironLegisChangedListener extends ModelListener<FieldModel<any>> {
  constructor(private readonly suffix: 'Part' | 'Lot') {
    super();
  }

  onChange(model: FieldModel<any>): void {
    const lot = ModelStateService.findLotOrPartOfModel(model as BaseModel, this.suffix);
    const opt301Model: FieldModel<any> = ModelStateService.findModelById(
      lot as ModelWithChildren,
      `OPT-301-${this.suffix}-EnvironLegis`
    );
    const opt120Model: FieldModel<any> = ModelStateService.findModelById(
      lot as ModelWithChildren,
      `OPT-120-${this.suffix}-EnvironLegis`
    );
    const opt112Model: FieldModel<any> = ModelStateService.findModelById(
      lot as ModelWithChildren,
      `OPT-112-${this.suffix}-EnvironLegis`
    );

    if (!opt112Model) {
      return;
    }

    if (opt301Model?.value || opt120Model?.value) {
      opt112Model.value = 'n.a.';
      opt112Model.emitChange();
    }
  }

  shouldAttach(model: FieldModel<any>): boolean {
    return (
      model.noticeNode?.id === `OPT-301-${this.suffix}-EnvironLegis` ||
      model.noticeNode?.id === `OPT-120-${this.suffix}-EnvironLegis`
    );
  }
}
